/**
 * Mirrors the backend rule (location-client-profile/calculator-access.ts):
 * the org has the calculator AND this person may use it (they are the org's
 * own login, an admin, or were granted it). Staff are not gated here.
 */
export const orgHasCalculator = (user: any): boolean =>
  user?.client?.parent
    ? user.client.parent.portalCalculatorEnabled === true || user.client.parent.portalLocationsEnabled === true
    : user?.client?.portalCalculatorEnabled === true || user?.client?.portalLocationsEnabled === true;

export const personHasCalculator = (user: any): boolean => {
  const c = user?.client;
  if (!c?.id) return false;
  if (!c.parent) return true;
  if (c.companyAdmin === true || Number(c.companyAdmin) === 1) return true;
  return Number(c.portalCalculatorAccess) === 1 || c.portalCalculatorAccess === true;
};

/** Org switch (staff-set): the org's admin manages their own users. */
export const orgManagesUsers = (user: any): boolean => {
  const v = user?.client?.parent?.portalUserManagementEnabled;
  return v === true || Number(v) === 1;
};
